import { AnyAction } from 'redux';
import createSagaMiddleware from 'redux-saga';
import combineSectionReducers from 'combine-section-reducers';
import {
  GlobalPut,
  integrateReduxDevtoolsExtension,
  NgRefreshStore,
  PS20Store,
} from '@ps20-frontend/shop-integration-redux';
import { App, Produkt } from '@ps20-frontend/frontend-models';
import {
  gesamtbeitragMitRabattReducer,
  gesamtbeitragReducerForApp,
  jahresbeitragReducer,
  produktReducer,
} from '@ps20-frontend/reducers';
import { configureStore, Dispatch, Middleware, Tuple, UnknownAction } from '@reduxjs/toolkit';
import { rootSaga } from './sagas/rootSaga';

import { rootReducer } from './reducers/rootReducer.reducer';

import { INITIAL_STATE } from './initialState';

import { IAppState } from './appState';
import { transientStateReducer } from './reducers/transient-state.reducer';
import { antragsnummerReducer } from './reducers/antragsnummer.reducer';
import { versicherungsnehmerReducer } from './reducers/versicherungsnehmer.reducer';
import { jhpVertragsoptionenReducer } from './reducers/vertragsoptionen.reducer';
import { jhpTaasInfoReducer } from './reducers/jhpTaasInfo.reducer';

export const reducers = combineSectionReducers({
  version: (version: number = null) => version,
  antragsnummer: antragsnummerReducer,
  transientState: transientStateReducer,
  versicherungsnehmer: versicherungsnehmerReducer,
  gesamtbeitragMitRabatt: gesamtbeitragMitRabattReducer,
  jahresbeitrag: jahresbeitragReducer,
  vertragsoptionen: jhpVertragsoptionenReducer,
  produkt: (sectionState: Produkt, action: AnyAction) =>
    produktReducer(sectionState, action, App.JHP),
  gesamtbeitrag: gesamtbeitragReducerForApp(App.JHP),
  taasInfo: jhpTaasInfoReducer,
  rabattstufe: (rabatstuffe: number = null) => rabatstuffe,
});

export function storeFactory(initialState: IAppState): PS20Store<IAppState> {
  const ngRefreshStore = new NgRefreshStore<IAppState>(App.JHP);
  const sagaMiddleware = createSagaMiddleware();
  const store = configureStore({
    reducer: rootReducer(reducers),
    devTools: integrateReduxDevtoolsExtension('jhp-angebot-gui'),
    preloadedState: initialState,
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware().concat(sagaMiddleware, ngRefreshStore.ngRefreshMiddleware) as unknown as Tuple<ReadonlyArray<Middleware<Record<string, never>, IAppState, Dispatch<UnknownAction>>>>,
  });
  sagaMiddleware.run(rootSaga);
  ngRefreshStore.setDelegate(store);
  return ngRefreshStore;
}

export const localStore: PS20Store<IAppState> = storeFactory(INITIAL_STATE);

GlobalPut.getInstance().globalEventDispatcherFunction = () => {
  return localStore.globalEventDispatcherRef;
};
